import { autoinject } from 'aurelia-framework';
import { EntityManager } from 'aurelia-orm';

@autoinject
export class Lookup {
  lookupRepository: any;
  utilities: any[] = []; 
  states: any[] = []; 
  languages: any[] = [];
  countries: any[] = [];
  titles: any[] = [];
  maritalStatuses: any[] = [];
  cities: any[] = [];
  streetParts: any[] = [];
  constructor(private entityManager: EntityManager) {
    this.lookupRepository = entityManager.getRepository('lookup');
  }
  async load() {
    try {
      let lookupResult = await this.lookupRepository.find();
      this.processLookupResult(lookupResult);
    } catch (e) {

    }
  }
  private processLookupResult(lookupResult: any) {
    this.utilities = lookupResult.utilities;
    this.states = lookupResult.states;
    this.languages = lookupResult.languages;
    this.countries = lookupResult.countries;
    this.titles = lookupResult.titles;
    this.maritalStatuses = lookupResult.maritalStatuses;
    this.cities = lookupResult.cities;
    this.streetParts = lookupResult.streetParts;
  }
}
